import { render, staticRenderFns } from "./WalletCharge.vue?vue&type=template&id=66ec00a5&scoped=true"
import script from "./WalletCharge.vue?vue&type=script&lang=js"
export * from "./WalletCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ec00a5",
  null
  
)

export default component.exports